function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o)
    return; if (typeof o === "string")
    return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor)
    n = o.constructor.name; if (n === "Map" || n === "Set")
    return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length)
    len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++)
    arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) {
    var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
    try {
        if (_x = (_i = _i.call(arr)).next, 0 === i) {
            if (Object(_i) !== _i)
                return;
            _n = !1;
        }
        else
            for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0)
                ;
    }
    catch (err) {
        _d = !0, _e = err;
    }
    finally {
        try {
            if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r))
                return;
        }
        finally {
            if (_d)
                throw _e;
        }
    }
    return _arr;
} }
function _arrayWithHoles(arr) { if (Array.isArray(arr))
    return arr; }
import { useState } from 'react';
import { Button, Header, Radio, RadioGroup } from '@nordlayer/rivendell-ui';
import { TENANTS } from 'types/auth/constants';
import { IS_DEV_ENV } from 'settings';
import { getJumpCloudSsoPath } from 'api/Auth/apiPaths';
import { getApiUrl } from 'api/utils/url';
import { PublicPageContainer } from 'templates/PublicPageContainer';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var Login = function Login() {
    var _useState = useState(null), _useState2 = _slicedToArray(_useState, 2), organization = _useState2[0], setOrganization = _useState2[1];
    var handleContinue = function handleContinue() {
        if (!organization) {
            return;
        }
        var loginUrl = new URL(getApiUrl(getJumpCloudSsoPath(organization)));
        if (IS_DEV_ENV) {
            loginUrl.searchParams.set('redirect_url', "".concat(window.location.origin, "/oidc/").concat(organization, "/callback"));
        }
        window.location.assign(loginUrl.toString());
    };
    return /*#__PURE__*/ _jsxs(PublicPageContainer, {
        children: [/*#__PURE__*/ _jsx(Header, {
                title: "Log in using JumpCloud",
                description: "Select organization"
            }), /*#__PURE__*/ _jsxs(RadioGroup, {
                name: "organization",
                "aria-label": "Select organization",
                orientation: "vertical",
                onChange: function onChange(value) {
                    return setOrganization(value);
                },
                value: organization,
                children: [/*#__PURE__*/ _jsx(Radio, {
                        mode: "card",
                        value: TENANTS.NORDSECURITY,
                        isBold: true,
                        children: "NordSecurity"
                    }), /*#__PURE__*/ _jsx(Radio, {
                        mode: "card",
                        value: TENANTS.CYBERCARE,
                        isBold: true,
                        children: "CyberCare"
                    })]
            }), /*#__PURE__*/ _jsx(Button, {
                stretch: true,
                onPress: handleContinue,
                isDisabled: !organization,
                size: "md",
                children: "Continue"
            })]
    });
};
